import {call, put} from 'redux-saga/effects';
import SearchActions from '../redux/SearchRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getSearch(api, action) {
  const {isShort, query} = action;
  const response = yield call(api.getSearch, {isShort, query});

  if (response.ok) {
    yield put(SearchActions.searchSuccess(transformData(response.data)));
  } else {
    yield put(SearchActions.searchFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transformData = data => {
  let newData = {};
  Object.keys(data).map(key => {
    if (data[key].length && data[key].length > 0) {
      newData[key] = data[key];
    }
  })
  return newData;
}